import { ReactComponent as HeaderLogo } from './images/icons/HeaderLogo.svg';
import { ReactComponent as FooterLogo } from './images/icons/FooterLogo.svg';
import { ReactComponent as SmsSvg } from './images/icons/sms.svg';
import { ReactComponent as LockPassSvg } from './images/icons/LockPass.svg';
import { ReactComponent as CheckSvg } from './images/icons/CheckSvg.svg';
import { ReactComponent as Check2Svg } from './images/icons/Check2Svg.svg';
import { ReactComponent as CloseSvg } from './images/icons/CloseSvg.svg';
import { ReactComponent as EyeSvg } from './images/icons/EyeSvg.svg';
import { ReactComponent as EyeHideSvg } from './images/icons/EyeHideSvg.svg';
import { ReactComponent as CheckEmailSvg } from './images/icons/CheckEmailSvg.svg';
import { ReactComponent as BookHelpSvg } from './images/icons/BookHelpSvg.svg';
import { ReactComponent as ArrowRight2Svg } from './images/icons/ArrowRight2Svg.svg';
import { ReactComponent as NotificationsActiveSvg } from './images/icons/NotificationsActiveSvg.svg';
import { ReactComponent as PlusCircle } from './images/icons/plusCircle.svg';
import { ReactComponent as EmptyNotAndAlerts } from './images/icons/EmptyNotAndAlerts.svg';
import { ReactComponent as ArrowRight3 } from './images/icons/ArrowRight3.svg';
import { ReactComponent as CheckIcon } from './images/icons/checkIcon.svg';
import { ReactComponent as UsersSvg } from './images/icons/UsersSvg.svg';
import { ReactComponent as UsersPlusSvg } from './images/icons/UsersPlusSvg.svg';
import { ReactComponent as AwardSvg } from './images/icons/AwardSvg.svg';
import { ReactComponent as FreeMonthsSvg } from './images/landingPage/landingImages/FreeMonthsSvg.svg';
import { ReactComponent as FreeOnboardingSvg } from './images/landingPage/landingImages/FreeOnboardingSvg.svg';
import { ReactComponent as FreeDataTransferSvg } from './images/landingPage/landingImages/FreeDataTransferSvg.svg';
import { ReactComponent as FreeSupportSvg } from './images/landingPage/landingImages/FreeSupportSvg.svg';
import {
    ReactComponent as DisconnectedSystemsSvg,
} from './images/landingPage/landingImages/DisconnectedSystemsSvg.svg';
import { ReactComponent as DataEntrySvg } from './images/landingPage/landingImages/DataEntrySvg.svg';
import { ReactComponent as PoorUserSvg } from './images/landingPage/landingImages/PoorUserSvg.svg';
import { ReactComponent as LimitedReportingSvg } from './images/landingPage/landingImages/LimitedReportingSvg.svg';
import { ReactComponent as HiddenFeesSvg } from './images/landingPage/landingImages/HiddenFeesSvg.svg';
import { ReactComponent as SlowSupportSvg } from './images/landingPage/landingImages/SlowSupportSvg.svg';
import { ReactComponent as ContactMail } from './images/landingPage/landingImages/contactMail.svg';
import { ReactComponent as ContactPhone } from './images/landingPage/landingImages/contactPhone.svg';
import { ReactComponent as ContactMapPin } from './images/landingPage/landingImages/contactMapPin.svg';
import MenuIcon from './images/landingPage/topBar/menuIcon.svg';
import MenuCloseIcon from './images/landingPage/topBar/menuCloseIcon.svg';
import ClientMgmt from './images/landingPage/home/clientMgmt.svg';
import ClientMgmtMark from './images/landingPage/home/clientMgmtMark.svg';
import ClientMgmtScreen from './images/landingPage/home/clientMgmtScreen.png';
import StaffMgmt from './images/landingPage/home/staffMgmt.png';
import StaffMgmtMark from './images/landingPage/home/staffMgmtMark.png';
import StaffMgmtScreen from './images/landingPage/home/staffMgmtScreen.png';
import FSMgmt from './images/landingPage/home/fsMgmt.png';
import FSMgmtMark from './images/landingPage/home/fsMgmtMark.png';
import FSMgmtScreen from './images/landingPage/home/fsMgmtScreen.png';
import AccessMgmt from './images/landingPage/home/accessMgmt.png';
import AccessMgmtMark from './images/landingPage/home/accessMgmtMark.png';
import AccessMgmtScreen from './images/landingPage/home/accessMgmtScreen.png';
import Scheduling from './images/landingPage/home/scheduling.svg';
import SchedulingMark from './images/landingPage/home/schedulingMark.png';
import SchedulingScreen from './images/landingPage/home/schedulingScreen.png';
import Billing from './images/landingPage/home/billing.svg';
import BillingMark from './images/landingPage/home/billingMark.svg';
import BillingScreen from './images/landingPage/home/billingScreen.png';
import CustomerOne from './images/landingPage/home/customerOne.png';
import CustomerTwo from './images/landingPage/home/customerTwo.png';
import Quotes from './images/landingPage/home/quotes.svg';
import LeftArrow from './images/landingPage/home/leftArrow.svg';
import RightArrow from './images/landingPage/home/rightArrow.svg';
import bannerImg from './images/landingPage/home/bannerImg.png';
import bannerImgSmall from './images/landingPage/home/bannerImgSmall.png';
import whyTherapyBeck from './images/landingPage/landingImages/whyTherapyBeck.png';
import whyTherapyBeckSmall from './images/landingPage/landingImages/whyTherapyBeckSmall.png';
import bannerInfoImg from './images/landingPage/home/bannerInfoImg.png';

import smartScheduling from './images/landingPage/home/smartScheduling.png';
import authorizationComplianceTracking from './images/landingPage/home/authorizationComplianceTracking.png';
import billingClaimsAutomation from './images/landingPage/home/billingClaimsAutomation.png';
import clientStaffManagement from './images/landingPage/home/clientStaffManagement.png';
import taskWorkflow from './images/landingPage/home/taskWorkflow.png';
import reports from './images/landingPage/home/reports.png';

import masteryTracking from './images/landingPage/home/masteryTracking.png';
import integratedNotes from './images/landingPage/home/integratedNotes.png';
import quickSession from './images/landingPage/home/quickSession.png';
import templatesPrompt from './images/landingPage/home/templatesPrompt.png';
import mobileFirstData from './images/landingPage/home/mobileFirstData.png';
import offlineMode from './images/landingPage/home/offlineMode.png';

import clinicalHeroImgSmall from './images/landingPage/dataCollection/clinicalHeroImgSmall.png';
import clinicalHeroImg from './images/landingPage/dataCollection/clinicalHeroImg.png';
import realTimeImg from './images/landingPage/dataCollection/realTimeImg.png';
import realTimeImgSmall from './images/landingPage/dataCollection/realTimeImgSmall.png';
import customProgramsImg from './images/landingPage/dataCollection/customProgramsImg.png';
import customProgramsImgSmall from './images/landingPage/dataCollection/customProgramsImgSmall.png';
import integratedSessionImg from './images/landingPage/dataCollection/integratedSessionImg.png';
import integratedSessionImgSmall from './images/landingPage/dataCollection/integratedSessionImgSmall.png';
import automatedGraphingImg from './images/landingPage/dataCollection/automatedGraphingImg.png';
import automatedGraphingImgSmall from './images/landingPage/dataCollection/automatedGraphingImgSmall.png';
import oneLoginImg from './images/landingPage/dataCollection/oneLoginImg.png';
import oneLoginImgSmall from './images/landingPage/dataCollection/oneLoginImgSmall.png';
import readySecurityImg from './images/landingPage/dataCollection/readySecurityImg.png';
import readySecurityImgSmall from './images/landingPage/dataCollection/readySecurityImgSmall.png';

import practiceHeroImg from './images/landingPage/practiceManagement/practiceHeroImg.png';
import practiceHeroImgSmall from './images/landingPage/practiceManagement/practiceHeroImgSmall.png';
import completelyAutomatedImg from './images/landingPage/practiceManagement/completelyAutomatedImg.png';
import completelyAutomatedImgSmall from './images/landingPage/practiceManagement/completelyAutomatedImgSmall.png';
import smartSchedulingImg from './images/landingPage/practiceManagement/smartSchedulingImg.png';
import smartSchedulingImgSmall from './images/landingPage/practiceManagement/smartSchedulingImgSmall.png';
import payrollReadyImg from './images/landingPage/practiceManagement/payrollReadyImg.png';
import payrollReadyImgSmall from './images/landingPage/practiceManagement/payrollReadyImgSmall.png';
import customReportingImg from './images/landingPage/practiceManagement/customReportingImg.png';
import customReportingImgSmall from './images/landingPage/practiceManagement/customReportingImgSmall.png';
import mobileAppFunctionalityImg from './images/landingPage/practiceManagement/mobileAppFunctionalityImg.png';
import mobileAppFunctionalityImgSmall from './images/landingPage/practiceManagement/mobileAppFunctionalityImgSmall.png';
import onePlatformImg from './images/landingPage/practiceManagement/onePlatformImg.png';
import onePlatformImgSmall from './images/landingPage/practiceManagement/onePlatformImgSmall.png';
import alignedSecurityImg from './images/landingPage/practiceManagement/alignedSecurityImg.png';
import alignedSecurityImgSmall from './images/landingPage/practiceManagement/alignedSecurityImgSmall.png';

import abaBillingHeroImg from './images/landingPage/abaBillingSoftware/abaBillingHeroImg.png';
import abaBillingHeroImgSmall from './images/landingPage/abaBillingSoftware/abaBillingHeroImgSmall.png';
import abaBillingGuardrailsImgSmall from './images/landingPage/abaBillingSoftware/abaBillingGuardrailsImgSmall.png';
import abaBillingGuardrailsImg from './images/landingPage/abaBillingSoftware/abaBillingGuardrailsImg.png';
import abaBillingRcmAgentsImgSmall from './images/landingPage/abaBillingSoftware/abaBillingRcmAgentsImgSmall.png';
import abaBillingRcmAgentsImg from './images/landingPage/abaBillingSoftware/abaBillingRcmAgentsImg.png';
import abaBillingAutomatedImgSmall from './images/landingPage/abaBillingSoftware/abaBillingAutomatedImgSmall.png';
import abaBillingAutomatedImg from './images/landingPage/abaBillingSoftware/abaBillingAutomatedImg.png';
import abaBillingEligibilityImgSmall from './images/landingPage/abaBillingSoftware/abaBillingEligibilityImgSmall.png';
import abaBillingEligibilityImg from './images/landingPage/abaBillingSoftware/abaBillingEligibilityImg.png';
import abaBillingReportingImgSmall from './images/landingPage/abaBillingSoftware/abaBillingReportingImgSmall.png';
import abaBillingReportingImg from './images/landingPage/abaBillingSoftware/abaBillingReportingImg.png';
import abaBillingConnectedImgSmall from './images/landingPage/abaBillingSoftware/abaBillingConnectedImgSmall.png';
import abaBillingConnectedImg from './images/landingPage/abaBillingSoftware/abaBillingConnectedImg.png';
import abaBillingRcmServicesImgSmall from './images/landingPage/abaBillingSoftware/abaBillingRcmServicesImgSmall.png';
import abaBillingRcmServicesImg from './images/landingPage/abaBillingSoftware/abaBillingRcmServicesImg.png';

import managedBillingHeroImgSmall from './images/landingPage/managedBilling/managedBillingHeroImgSmall.png';
import managedBillingHeroImg from './images/landingPage/managedBilling/managedBillingHeroImg.png';
import managedBillingWorkflowsImgSmall from './images/landingPage/managedBilling/managedBillingWorkflowsImgSmall.png';
import managedBillingWorkflowsImg from './images/landingPage/managedBilling/managedBillingWorkflowsImg.png';
import managedBillingSpecialistsImgSmall
    from './images/landingPage/managedBilling/managedBillingSpecialistsImgSmall.png';
import managedBillingSpecialistsImg from './images/landingPage/managedBilling/managedBillingSpecialistsImg.png';
import managedBillingVisibilityImgSmall from './images/landingPage/managedBilling/managedBillingVisibilityImgSmall.png';
import managedBillingVisibilityImg from './images/landingPage/managedBilling/managedBillingVisibilityImg.png';
import managedBillingCleanerDataImgSmall
    from './images/landingPage/managedBilling/managedBillingCleanerDataImgSmall.png';
import managedBillingCleanerDataImg from './images/landingPage/managedBilling/managedBillingCleanerDataImg.png';
import managedBillingProactiveRcmImgSmall
    from './images/landingPage/managedBilling/managedBillingProactiveRcmImgSmall.png';
import managedBillingProactiveRcmImg from './images/landingPage/managedBilling/managedBillingProactiveRcmImg.png';
import managedBillingSecurityImgSmall from './images/landingPage/managedBilling/managedBillingSecurityImgSmall.png';
import managedBillingSecurityImg from './images/landingPage/managedBilling/managedBillingSecurityImg.png';


import abaSchedulingHeroImgSmall from './images/landingPage/abaScheduling/abaSchedulingHeroImgSmall.png';
import abaSchedulingHeroImg from './images/landingPage/abaScheduling/abaSchedulingHeroImg.png';
import abaSchedulingGuardrailsImgSmall from './images/landingPage/abaScheduling/abaSchedulingGuardrailsImgSmall.png';
import abaSchedulingGuardrailsImg from './images/landingPage/abaScheduling/abaSchedulingGuardrailsImg.png';
import abaSchedulingRecurringImgSmall from './images/landingPage/abaScheduling/abaSchedulingRecurringImgSmall.png';
import abaSchedulingRecurringImg from './images/landingPage/abaScheduling/abaSchedulingRecurringImg.png';
import abaSchedulingAuthImgSmall from './images/landingPage/abaScheduling/abaSchedulingAuthImgSmall.png';
import abaSchedulingAuthImg from './images/landingPage/abaScheduling/abaSchedulingAuthImg.png';
import abaSchedulingStaffImgSmall from './images/landingPage/abaScheduling/abaSchedulingStaffImgSmall.png';
import abaSchedulingStaffImg from './images/landingPage/abaScheduling/abaSchedulingStaffImg.png';
import abaSchedulingAvailabilityImgSmall
    from './images/landingPage/abaScheduling/abaSchedulingAvailabilityImgSmall.png';
import abaSchedulingAvailabilityImg from './images/landingPage/abaScheduling/abaSchedulingAvailabilityImg.png';
import abaSchedulingAnalyticsImgSmall from './images/landingPage/abaScheduling/abaSchedulingAnalyticsImgSmall.png';
import abaSchedulingAnalyticsImg from './images/landingPage/abaScheduling/abaSchedulingAnalyticsImg.png';


import bannerInfoImgSmall from './images/landingPage/home/bannerInfoImgSmall.png';
import schedulingCalendar from './images/landingPage/home/schedulingCalendar.png';
import empowering from './images/landingPage/landingImages/empowering.png';
import whyTherapyCard1 from './images/landingPage/landingImages/whyTherapyCard1.png';
import whyTherapyCard2 from './images/landingPage/landingImages/whyTherapyCard2.png';
import whyTherapyCard3 from './images/landingPage/landingImages/whyTherapyCard3.png';
import whyTherapyCard4 from './images/landingPage/landingImages/whyTherapyCard4.png';
import technologicalImg from './images/landingPage/landingImages/technologicalImg.png';
import accessKayImage from './images/landingPage/landingImages/accessKayImage.png';
import accessKayImageMobile from './images/landingPage/landingImages/accessKayImageMobile.png';
import vectorImg from './images/landingPage/landingImages/vectorImg.png';
import appStore from './images/landingPage/landingImages/appStore.png';
import googlePlay from './images/landingPage/landingImages/googlePlay.png';
import customerOne from './images/landingPage/landingImages/customerOne.png';
import customerTwo from './images/landingPage/landingImages/customerTwo.png';
import backInfinityFeatures from './images/landingPage/landingImages/backInfinityFeatures.png';
import { ReactComponent as ArrowRightSvg } from './images/icons/arrowRight.svg';
import { ReactComponent as OpenWidgetSvg } from './images/icons/OpenWidgetSvg.svg';
import { ReactComponent as DragHandleSvg } from './images/icons/DragHandleSvg.svg';
import { ReactComponent as CloseGraySvg } from './images/icons/CloseGraySvg.svg';
import { ReactComponent as ChevronRightSvg } from './images/icons/ChevronRightSvg.svg';
import { ReactComponent as AlertCircleSvg } from './images/icons/AlertCircleSvg.svg';
import { ReactComponent as AddCircleSvg } from './images/icons/AddCircleSvg.svg';
import { ReactComponent as CheckCircleSvg } from './images/icons/CheckCircleSvg.svg';
import { ReactComponent as UpcomingApptWidgetDash } from './images/widgets/upcomingApptWidgetDash.svg';
import { ReactComponent as ClientOverviewWidgetDash } from './images/widgets/clientOverviewWidgetDash.svg';
import { ReactComponent as ExpiringCredWidgetDash } from './images/widgets/expiringCredWidgetDash.svg';
import { ReactComponent as NotAlertsWidgetDash } from './images/widgets/notAlertsWidgetDash.svg';
import { ReactComponent as AssignedClientsWidgetDash } from './images/widgets/assignedClientsWidgetDash.svg';
import { ReactComponent as MyProfileWidgetDash } from './images/widgets/myProfileWidgetDash.svg';
import { ReactComponent as MyTasksWidgetDash } from './images/widgets/myTasksWidgetDash.svg';
import { ReactComponent as ExpiringAuthWidgetDash } from './images/widgets/expiringAuthWidgetDash.svg';
import { ReactComponent as InsuranceAlertsWidgetDash } from './images/widgets/insuranceAlertsWidgetDash.svg';
import { ReactComponent as SessionNoteReqWidgetDash } from './images/widgets/sessionNoteReqWidgetDash.svg';
import { ReactComponent as SessionNoteDocSvg } from './images/icons/sessionNoteDocSvg.svg';
import { ReactComponent as SessionNoteAddSvg } from './images/icons/sessionNoteAddSvg.svg';
import { ReactComponent as PlaySvg } from './images/icons/PlaySvg.svg';
import { ReactComponent as EMRSvg } from './images/landingPage/landingImages/EMRSvg.svg';
import { ReactComponent as ScheduleSvg } from './images/landingPage/landingImages/ScheduleSvg.svg';
import { ReactComponent as BillingSvg } from './images/landingPage/landingImages/BillingSvg.svg';
import { ReactComponent as PayrollPSvg } from './images/landingPage/landingImages/PayrollPSvg.svg';
import { ReactComponent as ReportingPSVG } from './images/landingPage/landingImages/ReportingPSVG.svg';
import { ReactComponent as RealTimePSVG } from './images/landingPage/landingImages/RealTimePSVG.svg';
import { ReactComponent as ProgramsPSVG } from './images/landingPage/landingImages/ProgramsPSVG.svg';
import { ReactComponent as SessionNotesPSVG } from './images/landingPage/landingImages/SessionNotesPSVG.svg';
import { ReactComponent as GraphsPSVG } from './images/landingPage/landingImages/GraphsPSVG.svg';
import { ReactComponent as FasterSvg } from './images/landingPage/landingImages/FasterSvg.svg';
import { ReactComponent as FewerSvg } from './images/landingPage/landingImages/FewerSvg.svg';
import { ReactComponent as FinancialSvg } from './images/landingPage/landingImages/FinancialSvg.svg';
import { ReactComponent as StressFreeSvg } from './images/landingPage/landingImages/StressFreeSvg.svg';

import { ReactComponent as InfinitySmallSvg } from './images/landingPage/landingImages/InfinitySmallSvg.svg';
import { ReactComponent as StarOrangeSvg } from './images/landingPage/landingImages/StarOrangeSvg.svg';
import { ReactComponent as ArrowRightCarousel } from './images/landingPage/landingImages/ArrowRightCarousel.svg';
import { ReactComponent as ArrowLeftCarousel } from './images/landingPage/landingImages/ArrowLeftCarousel.svg';
import { ReactComponent as Checkmark } from './images/landingPage/landingImages/Checkmark.svg';
import { ReactComponent as CheckMarkSvg } from './images/landingPage/landingImages/CheckmarkSvg.svg';
import { ReactComponent as FacebookFooter } from './images/landingPage/footer/FacebookFooter.svg';
import { ReactComponent as LinkedinFooter } from './images/landingPage/footer/LinkedinFooter.svg';
import { ReactComponent as YoutubeFooter } from './images/landingPage/footer/YoutubeFooter.svg';
import { ReactComponent as InstagramFooter } from './images/landingPage/footer/InstagramFooter.svg';
import { ReactComponent as TwitterFooter } from './images/landingPage/footer/TwitterFooter.svg';
import { ReactComponent as PManagementSvg } from './images/landingPage/home/PManagementSvg.svg';
import { ReactComponent as DataCollSvg } from './images/landingPage/home/DataCollSvg.svg';
import { ReactComponent as RCycleSvg } from './images/landingPage/home/RCycleSvg.svg';
import { ReactComponent as VectorSvg } from './images/landingPage/home/VectorSvg.svg';
import { ReactComponent as ZapSvg } from './images/landingPage/landingImages/ZapSvg.svg';
import { ReactComponent as FirstlineSvg } from './images/landingPage/landingImages/FirstlineSvg.svg';
import { ReactComponent as Note2Svg } from './images/landingPage/landingImages/Note2Svg.svg';
import { ReactComponent as BarChart2Svg } from './images/landingPage/landingImages/BarChart2Svg.svg';
import { ReactComponent as Square3Svg } from './images/landingPage/landingImages/Square3Svg.svg';
import { ReactComponent as SecuritySafeSvg } from './images/landingPage/landingImages/SecuritySafeSvg.svg';
import { ReactComponent as ReceiptItemSvg } from './images/icons/ReceiptItemSvg.svg';
import { ReactComponent as ReceiptSvg } from './images/icons/ReceiptSvg.svg';
import { ReactComponent as Calendar2Svg } from './images/icons/Calendar2Svg.svg';
import { ReactComponent as MathSvg } from './images/icons/MathSvg.svg';
import { ReactComponent as CardEditSvg } from './images/icons/CardEditSvg.svg';
import { ReactComponent as MobileSvg } from './images/icons/MobileSvg.svg';
import { ReactComponent as ZoomCardSvg } from './images/icons/ZoomCardSvg.svg';
import { ReactComponent as VbMappCardSvg } from './images/icons/VbMappCardSvg.svg';
import { ReactComponent as GCalendarCardSvg } from './images/icons/GCalendarCardSvg.svg';
import { ReactComponent as OfficeAllyCardSvg } from './images/icons/OfficeAllyCardSvg.svg';
import { ReactComponent as AvailityCardSvg } from './images/icons/AvailityCardSvg.svg';
import { ReactComponent as StripeCardSvg } from './images/icons/StripeCardSvg.svg';
import { ReactComponent as TaskSvg } from './images/icons/TaskSvg.svg';
import { ReactComponent as ArchiveTickSvg } from './images/icons/ArchiveTickSvg.svg';
import { ReactComponent as PeopleSvg } from './images/icons/PeopleSvg.svg';
import { ReactComponent as PersonalCardSvg } from './images/icons/PersonalCardSvg.svg';
import { ReactComponent as DiagramSvg } from './images/icons/DiagramSvg.svg';
import { ReactComponent as LinkSvg } from './images/icons/LinkSvg.svg';
import { ReactComponent as OnlineSupportSvg } from './images/icons/OnlineSupportSvg.svg';
import { ReactComponent as ShieldTickSvg } from './images/icons/ShieldTickSvg.svg';
import { ReactComponent as RepeatSvg } from './images/icons/RepeatSvg.svg';
import { ReactComponent as Profile2UserSvg } from './images/icons/Profile2UserSvg.svg';
import { ReactComponent as ChartSvg } from './images/icons/ChartSvg.svg';

// ABOUT_US_PAGE_IMAGES
import AboutUsBanner from './images/landingPage/aboutUs/AboutUsBanner.png';
import banner1 from './images/landingPage/aboutUs/banner1.jpg';
import banner1hovered from './images/landingPage/aboutUs/banner1hovered.jpg';
import theMissionImg from './images/landingPage/aboutUs/theMissionImg.png';
import getInTouchBg from './images/landingPage/aboutUs/getInTouch-bg.png';

// ABOUT_US_PAGE_SVG
import { ReactComponent as OurBeginningsSvg } from './images/landingPage/aboutUs/OurBeginningsSvg.svg';
import { ReactComponent as GrowthSvg } from './images/landingPage/aboutUs/GrowthSvg.svg';
import { ReactComponent as NetworkSvg } from './images/landingPage/aboutUs/NetworkSvg.svg';
import { ReactComponent as InnovationSvg } from './images/landingPage/aboutUs/InnovationSvg.svg';
import { ReactComponent as IntegritySvg } from './images/landingPage/aboutUs/IntegritySvg.svg';
import { ReactComponent as CollaborationSvg } from './images/landingPage/aboutUs/CollaborationSvg.svg';

// CONTACT_US_PAGE_IMAGES
import { ReactComponent as ArrowDownSvg } from './images/landingPage/contactUs/ArrowDownSvg.svg';
import { ReactComponent as callIconSvg } from './images/landingPage/contactUs/callIconSvg.svg';
import { ReactComponent as SmsStarSvg } from './images/landingPage/contactUs/SmsStarSvg.svg';
import { ReactComponent as AddressSvg } from './images/landingPage/contactUs/AddressSvg.svg';
import { ReactComponent as FacebookContactSvg } from './images/landingPage/contactUs/FacebookContactSvg.svg';
import { ReactComponent as LinkedinContactSvg } from './images/landingPage/contactUs/LinkedinContactSvg.svg';
import { ReactComponent as TwitterContactSvg } from './images/landingPage/contactUs/TwitterContactSvg.svg';
import { ReactComponent as InstagramContact } from './images/landingPage/contactUs/InstagramContact.svg';

// FEATURES_PAGE_SVG
import { ReactComponent as FundingSourceSvg } from './images/landingPage/features/FundingSourceSvg.svg';
import { ReactComponent as ClientManagementSvg } from './images/landingPage/features/ClientManagementSvg.svg';
import { ReactComponent as StaffManagementSvg } from './images/landingPage/features/StaffManagementSvg.svg';
import { ReactComponent as GooglePlaySvg } from './images/landingPage/features/GooglePlaySvg.svg';
import { ReactComponent as GooglePlay } from './images/landingPage/features/GooglePlay.svg';
import { ReactComponent as GetItOnSvg } from './images/landingPage/features/GetItOnSvg.svg';
import { ReactComponent as AppleSvg } from './images/landingPage/features/AppleSvg.svg';
import { ReactComponent as DownloadOnThe } from './images/landingPage/features/DownloadOnThe.svg';
import { ReactComponent as AppStoreSvg } from './images/landingPage/features/AppStoreSvg.svg';

// FEATURES_PAGE_IMAGES

import electronic from './images/landingPage/features/electronic.png';
import electronicWeb from './images/landingPage/features/electronicWeb.png';
import schedulingImg from './images/landingPage/features/schedulingImg.png';
import aiPowered from './images/landingPage/features/aiPowered.png';
import autoClaims from './images/landingPage/features/autoClaims.png';
import payrollManag from './images/landingPage/features/payrollManag.png';
import billingDegree from './images/landingPage/features/billingDegree.png';
import powerfulIntegrations from './images/landingPage/features/powerfulIntegrations.png';
import customizableReports from './images/landingPage/features/customizableReports.png';
import customizableReportsTablet from './images/landingPage/features/customizableReportsTablet.png';
import accessKeyFeatures from './images/landingPage/features/accessKeyFeatures.png';
import accessKeyFeaturesTablet from './images/landingPage/features/accessKeyFeaturesTablet.png';
import dataSecurity from './images/landingPage/features/dataSecurity.png';
import credentialing from './images/landingPage/features/credentialing.png';
import billingDirect from './images/landingPage/features/billingDirect.png';
import billingConsulting from './images/landingPage/features/billingConsulting.png';
import billingPosting from './images/landingPage/features/billingPosting.png';

// HELP_CENTER_PAGE_IMAGES
import Knowledge from './images/landingPage/helpCenter/knowledge.png';
import ScheduleScreen from './images/landingPage/helpCenter/scheduleScreen.png';

// NOT_FOUND_PAGE_IMAGES
import Warning from './images/landingPage/notFound/warning.png';

// COMMON_IMAGES_AND_ICONS
import CloseIcon from './images/landingPage/common/closeIcon.svg';
import MenuMobileIcon from './images/landingPage/common/menuMobileIcon.png';

import logo from './images/landingPage/topBar/logo.svg';
import ScheduleTab from './images/icons/scheduleTab.svg';
import ScheduleTabDone from './images/icons/scheduleTabDone.svg';

import { ReactComponent as BlackLogo } from './images/landingPage/landingImages/blackLogo.svg';
import ButtonArrow from './images/landingPage/landingImages/buttonArrow.svg';
import { ReactComponent as Play } from './images/landingPage/landingImages/play.svg';
import HomeClient from './images/landingPage/landingImages/homeClient.png';

import authImage from './images/authImage.png';
import authImageSmall from './images/authImageSmall.png';

//HELP-CENTER-IMAGES

import createRoleDesktop from './images/helpCenter/createRoleDesktop.png';
import createRole2Desktop from './images/helpCenter/createRole2Desktop.png';
import createRole3Desktop from './images/helpCenter/createRole3Desktop.png';
import addPermDesktop from './images/helpCenter/addPermDesktop.png';
import deletingPermDesktop from './images/helpCenter/deletingPermDesktop.png';
import deletingPerm2Desktop from './images/helpCenter/deletingPerm2Desktop.png';
import deletingRoleDesktop from './images/helpCenter/deletingRoleDesktop.png';
import deletingRole2Desktop from './images/helpCenter/deletingRole2Desktop.png';
import renamingRolesSelect from './images/helpCenter/renamingRolesSelect.png';
import renamingRolesEdit from './images/helpCenter/renamingRolesEdit.png';
import saveCompanyProfDesktop from './images/helpCenter/saveCompanyProfDesktop.png';
import editingCompPropDesktop from './images/helpCenter/editingCompPropDesktop.png';
import saveChangesDesktop from './images/helpCenter/saveChangesDesktop.png';
import saveServiceTypeDesktop from './images/helpCenter/saveServiceTypeDesktop.png';
import editingServiceDesktop1 from './images/helpCenter/editingServiceDesktop1.png';
import editingServiceDesktop2 from './images/helpCenter/editingServiceDesktop2.png';
import creatingCredDesktop1 from './images/helpCenter/creatingCredDesktop1.png';
import creatingCredDesktop2 from './images/helpCenter/creatingCredDesktop2.png';
import addingCovCredDesktop from './images/helpCenter/addingCovCredDesktop.png';
import editCredNameDesktop1 from './images/helpCenter/editCredNameDesktop1.png';
import editCredNameDesktop2 from './images/helpCenter/editCredNameDesktop2.png';
import deleteCovCredDesktop from './images/helpCenter/deleteCovCredDesktop.png';
import addingNewDepDesktop from './images/helpCenter/addingNewDepDesktop.png';
import editingDepDesktop1 from './images/helpCenter/editingDepDesktop1.png';
import editingDepDesktop2 from './images/helpCenter/editingDepDesktop2.png';
import addingNewJobDesktop from './images/helpCenter/addingNewJobDesktop.png';
import editingJobTitleDesktop1 from './images/helpCenter/editingJobTitleDesktop1.png';
import editingJobTitleDesktop2 from './images/helpCenter/editingJobTitleDesktop2.png';
import addingPayTypesDesktop from './images/helpCenter/addingPayTypesDesktop.png';
import editPayTypeDesktop1 from './images/helpCenter/editPayTypeDesktop1.png';
import editPayTypeDesktop2 from './images/helpCenter/editPayTypeDesktop2.png';
import addingMileageDesktop from './images/helpCenter/addingMileageDesktop.png';
import editingMilDesktop1 from './images/helpCenter/editingMilDesktop1.png';
import editingMilDesktop2 from './images/helpCenter/editingMilDesktop2.png';
import inactivatingMilDesktop from './images/helpCenter/inactivatingMilDesktop.png';
import referenceCommonDesktop from './images/helpCenter/referenceCommonDesktop.png';
import editingPlaceDesktop1 from './images/helpCenter/editingPlaceDesktop1.png';
import editingPlaceDesktop2 from './images/helpCenter/editingPlaceDesktop2.png';
import createPayerDesktop1 from './images/helpCenter/createPayerDesktop1.png';
import createPayerDesktop2 from './images/helpCenter/createPayerDesktop2.png';
import activeInactivePayerDesktop from './images/helpCenter/activeInactivePayerDesktop.png';
import addServPayerDesktop1 from './images/helpCenter/addServPayerDesktop1.png';
import addServPayerDesktop2 from './images/helpCenter/addServPayerDesktop2.png';
import addChargeRateDesktop1 from './images/helpCenter/addChargeRateDesktop1.png';
import addChargeRateDesktop2 from './images/helpCenter/addChargeRateDesktop2.png';
import addChargeRateDesktop3 from './images/helpCenter/addChargeRateDesktop3.png';
import billingSetupDesktop from './images/helpCenter/billingSetupDesktop.png';
import downloadingCsvDesktop from './images/helpCenter/downloadingCsvDesktop.png';
import editingPayerDesktop1 from './images/helpCenter/editingPayerDesktop1.png';
import editingPayerDesktop2 from './images/helpCenter/editingPayerDesktop2.png';
import editingPayerServiceDesktop1 from './images/helpCenter/editingPayerServiceDesktop1.png';
import editingPayerServiceDesktop2 from './images/helpCenter/editingPayerServiceDesktop2.png';
import addNotePayerDesktop from './images/helpCenter/addNotePayerDesktop.png';
import editingPayerNotesDesktop from './images/helpCenter/editingPayerNotesDesktop.png';
import deletePayerNotesDesktop from './images/helpCenter/deletePayerNotesDesktop.png';
import viewPayerChangeHistoryDesktop from './images/helpCenter/viewPayerChangeHistoryDesktop.png';
import uploadPayerFilesDesktop1 from './images/helpCenter/uploadPayerFilesDesktop1.png';
import uploadPayerFilesDesktop2 from './images/helpCenter/uploadPayerFilesDesktop2.png';
import editPayerFilesDesktop from './images/helpCenter/editPayerFilesDesktop.png';
import deletingPayerFilesDesktop from './images/helpCenter/deletingPayerFilesDesktop.png';
import downPayerFilesDesktop from './images/helpCenter/downPayerFilesDesktop.png';
import viewPayerFilesDesktop from './images/helpCenter/viewPayerFilesDesktop.png';
import changeProfDesktop from './images/helpCenter/changeProfDesktop.png';
import userChangePassDesktop from './images/helpCenter/userChangePassDesktop.png';
import addClientDesktop from './images/helpCenter/addClientDesktop.png';
import addContactClientDesktop from './images/helpCenter/addContactClientDesktop.png';
import addEnrolClientDesktop1 from './images/helpCenter/addEnrolClientDesktop1.png';
import addEnrolClientDesktop2 from './images/helpCenter/addEnrolClientDesktop2.png';
import addNoteClientDesktop from './images/helpCenter/addNoteClientDesktop.png';
import editClientFilesDesktop from './images/helpCenter/editClientFilesDesktop.png';
import editClientNoteDesktop from './images/helpCenter/editClientNoteDesktop.png';
import deleteClientNoteDesktop from './images/helpCenter/deleteClientNoteDesktop.png';
import addFileClientDesktop from './images/helpCenter/addFileClientDesktop.png';
import viewClientFileDesktop from './images/helpCenter/viewClientFileDesktop.png';
import editClientFileDesktop from './images/helpCenter/editClientFileDesktop.png';
import downClientFilesDesktop from './images/helpCenter/downClientFilesDesktop.png';
import deleteClientFilesDesktop from './images/helpCenter/deleteClientFilesDesktop.png';
import assignStaffClientDesktop from './images/helpCenter/assignStaffClientDesktop.png';
import deletAssignStaffClientDesktop from './images/helpCenter/deletAssignStaffClientDesktop.png';
import viwAssignStaffClientDesktop from './images/helpCenter/viwAssignStaffClientDesktop.png';
import addAuthClientDesktop1 from './images/helpCenter/addAuthClientDesktop1.png';
import addAuthClientDesktop2 from './images/helpCenter/addAuthClientDesktop2.png';
import addAuthServClientDesktop1 from './images/helpCenter/addAuthServClientDesktop1.png';
import addAuthServClientDesktop2 from './images/helpCenter/addAuthServClientDesktop2.png';
import editClientAuthDesktop1 from './images/helpCenter/editClientAuthDesktop1.png';
import editClientAuthDesktop2 from './images/helpCenter/editClientAuthDesktop2.png';
import editAuthServiceDesktop from './images/helpCenter/editAuthServiceDesktop.png';
import viewPastAuthDesktop1 from './images/helpCenter/viewPastAuthDesktop1.png';
import viewPastAuthDesktop2 from './images/helpCenter/viewPastAuthDesktop2.png';
import manageApptAuthDesktop1 from './images/helpCenter/manageApptAuthDesktop1.png';
import manageApptAuthDesktop2 from './images/helpCenter/manageApptAuthDesktop2.png';
import editClientContDesktop from './images/helpCenter/editClientContDesktop.png';
import deletClientContDesktop from './images/helpCenter/deletClientContDesktop.png';
import editGenInfoClientDesktop from './images/helpCenter/editGenInfoClientDesktop.png';
import editOtherInfoClientDesktop from './images/helpCenter/editOtherInfoClientDesktop.png';
import deleteAddressClientDesktop from './images/helpCenter/deleteAddressClientDesktop.png';
import editAddressClientDesktop from './images/helpCenter/editAddressClientDesktop.png';
import settingAddressAsDefDesktop1 from './images/helpCenter/settingAddressAsDefDesktop1.png';
import settingAddressAsDefDesktop2 from './images/helpCenter/settingAddressAsDefDesktop2.png';
import downClientCsvDesktop from './images/helpCenter/downClientCsvDesktop.png';
import viewClientPprofChangeDesktop from './images/helpCenter/viewClientPprofChangeDesktop.png';
import clientActiveInActiveDesktop from './images/helpCenter/clientActiveInActiveDesktop.png';
import editPrimSecondEnrollDesktop1 from './images/helpCenter/editPrimSecondEnrollDesktop1.png';
import editPrimSecondEnrollDesktop2 from './images/helpCenter/editPrimSecondEnrollDesktop2.png';
import termPrimSecondEnrolDesktop1 from './images/helpCenter/termPrimSecondEnrolDesktop1.png';
import termPrimSecondEnrolDesktop2 from './images/helpCenter/termPrimSecondEnrolDesktop2.png';
import settingSecondEnrollPrimDesktop1 from './images/helpCenter/settingSecondEnrollPrimDesktop1.png';
import settingSecondEnrollPrimDesktop2 from './images/helpCenter/settingSecondEnrollPrimDesktop2.png';
import addAddresClientDesktop from './images/helpCenter/addAddresClientDesktop.png';
import downCsvStaffDesktop from './images/helpCenter/downCsvStaffDesktop.png';
import addStaffDesktop1 from './images/helpCenter/addStaffDesktop1.png';
import addStaffDesktop2 from './images/helpCenter/addStaffDesktop2.png';
import addStaffPayDesktop1 from './images/helpCenter/addStaffPayDesktop1.png';
import addStaffPayDesktop2 from './images/helpCenter/addStaffPayDesktop2.png';
import addStaffTimePayDesktop1 from './images/helpCenter/addStaffTimePayDesktop1.png';
import addStaffTimePayDesktop2 from './images/helpCenter/addStaffTimePayDesktop2.png';
import addStaffTimeFixedPayDesktop1 from './images/helpCenter/addStaffTimeFixedPayDesktop1.png';
import addStaffTimeFixedPayDesktop2 from './images/helpCenter/addStaffTimeFixedPayDesktop2.png';
import addStaffCredDesktop1 from './images/helpCenter/addStaffCredDesktop1.png';
import addStaffCredDesktop2 from './images/helpCenter/addStaffCredDesktop2.png';
import addStaffNotesDesktop from './images/helpCenter/addStaffNotesDesktop.png';
import viewStaffProfChangeHistoryDesktop from './images/helpCenter/viewStaffProfChangeHistoryDesktop.png';
import addStaffFilesDesktop1 from './images/helpCenter/addStaffFilesDesktop1.png';
import addStaffFilesDesktop2 from './images/helpCenter/addStaffFilesDesktop2.png';
import addEditStaffGenInfoDesktoop1 from './images/helpCenter/addEditStaffGenInfoDesktoop1.png';
import addEditStaffGenInfoDesktoop2 from './images/helpCenter/addEditStaffGenInfoDesktoop2.png';
import addStaffOtherDetailsDesktop1 from './images/helpCenter/addStaffOtherDetailsDesktop1.png';
import addStaffOtherDetailsDesktop2 from './images/helpCenter/addStaffOtherDetailsDesktop2.png';
import addStaffCurrPastEmplDesktop1 from './images/helpCenter/addStaffCurrPastEmplDesktop1.png';
import addStaffCurrPastEmplDesktop2 from './images/helpCenter/addStaffCurrPastEmplDesktop2.png';
import viewStaffCurrentEmpDesktop1 from './images/helpCenter/viewStaffCurrentEmpDesktop1.png';
import viewStaffCurrentEmpDesktop2 from './images/helpCenter/viewStaffCurrentEmpDesktop2.png';
import viewStaffPastEmplDesktop from './images/helpCenter/viewStaffPastEmplDesktop.png';
import editStaffTimesheetDesktop from './images/helpCenter/editStaffTimesheetDesktop.png';
import editStaffCredentialDesktop from './images/helpCenter/editStaffCredentialDesktop.png';
import viewStaffCredDesktop from './images/helpCenter/viewStaffCredDesktop.png';
import deleteStaffCredDesktop from './images/helpCenter/deleteStaffCredDesktop.png';
import deleteStaffServiceDesktop from './images/helpCenter/deleteStaffServiceDesktop.png';
import editStaffNotesDesktop from './images/helpCenter/editStaffNotesDesktop.png';
import deleteStaffNotesDesktop from './images/helpCenter/deleteStaffNotesDesktop.png';
import deleteStaffFileDesktop from './images/helpCenter/deleteStaffFileDesktop.png';
import editStaffPastMemberDesktop1 from './images/helpCenter/editStaffPastMemberDesktop1.png';
import editStaffPastMemberDesktop2 from './images/helpCenter/editStaffPastMemberDesktop2.png';
import deleteStaffMemberEmployDesktop1 from './images/helpCenter/deleteStaffMemberEmployDesktop1.png';
import deleteStaffMemberEmployDesktop2 from './images/helpCenter/deleteStaffMemberEmployDesktop2.png';
import deleteStaffMemberEmployDesktop3 from './images/helpCenter/deleteStaffMemberEmployDesktop3.png';
import activeInactiveStaffDesktop from './images/helpCenter/activeInactiveStaffDesktop.png';
import viewPendClaimDesktop from './images/helpCenter/viewPendClaimDesktop.png';
import generateClaimDesktop1 from './images/helpCenter/generateClaimDesktop1.png';
import deleteStaffAccessDesktop from './images/helpCenter/deleteStaffAccessDesktop.png';
import changingNotificationDesktop1 from './images/helpCenter/changingNotificationDesktop1.png';
import changingNotificationDesktop2 from './images/helpCenter/changingNotificationDesktop2.png';
import activeInActivePayerServiceDesktop from './images/helpCenter/activeInActivePayerServiceDesktop.png';
import settingStaffAvailDesktop from './images/helpCenter/settingStaffAvailDesktop.png';
import addStaffAccessDesktop1 from './images/helpCenter/addStaffAccessDesktop1.png';
import addStaffAccessDesktop2 from './images/helpCenter/addStaffAccessDesktop2.png';
import addStaffServicesDesktop1 from './images/helpCenter/addStaffServicesDesktop1.png';
import addStaffServicesDesktop2 from './images/helpCenter/addStaffServicesDesktop2.png';
import changeClientStatusDesktop from './images/helpCenter/changeClientStatusDesktop.png';
import addPayersClientDesktop1 from './images/helpCenter/addPayersClientDesktop1.png';
import addPayersClientDesktop2 from './images/helpCenter/addPayersClientDesktop2.png';
import editPayerDesktop from './images/helpCenter/editPayerDesktop.png';
import inactivePayerDesktop from './images/helpCenter/inactivePayerDesktop.png';
import addAuthToClientDesktop1 from './images/helpCenter/addAuthToClientDesktop1.png';
import addAuthToClientDesktop2 from './images/helpCenter/addAuthToClientDesktop2.png';
import addAuthServiceSepDesktop1 from './images/helpCenter/addAuthServiceSepDesktop1.png';
import addAuthServiceSepDesktop2 from './images/helpCenter/addAuthServiceSepDesktop2.png';
import editAuthToClientDesktop from './images/helpCenter/editAuthToClientDesktop.png';
import editAuthServiceSepDesktop from './images/helpCenter/editAuthServiceSepDesktop.png';
import addFileToClientAuthDesktop from './images/helpCenter/addFileToClientAuthDesktop.png';
import cloneAuthClient from './images/helpCenter/cloneAuthClient.png';
import inactiveAuthServClientDesktop from './images/helpCenter/inactiveAuthServClientDesktop.png';
import settingClientAvailabilityDesktop from './images/helpCenter/settingClientAvailabilityDesktop.png';
import viewClientNotesDesktop from './images/helpCenter/viewClientNotesDesktop.png';
import backBtn from 'assets/images/icons/backBtn.svg';
import successMarkIcon from 'assets/images/icons/successMarkIcon.svg';
import alertError from 'assets/images/icons/alertError.png';
import { ReactComponent as ClipboardPlusSvg } from './images/icons/clipboardPlus.svg';

export const Images = {
    alertError,
    backBtn,
    successMarkIcon,
    // HELP-CENTER
    viewClientNotesDesktop,
    settingClientAvailabilityDesktop,
    inactiveAuthServClientDesktop,
    cloneAuthClient,
    addFileToClientAuthDesktop,
    editAuthServiceSepDesktop,
    editAuthToClientDesktop,
    addAuthServiceSepDesktop1,
    addAuthServiceSepDesktop2,
    addAuthToClientDesktop1,
    addAuthToClientDesktop2,
    inactivePayerDesktop,
    editPayerDesktop,
    addPayersClientDesktop1,
    addPayersClientDesktop2,
    changeClientStatusDesktop,
    addStaffServicesDesktop1,
    addStaffServicesDesktop2,
    addStaffAccessDesktop1,
    addStaffAccessDesktop2,
    activeInActivePayerServiceDesktop,
    changingNotificationDesktop1,
    changingNotificationDesktop2,
    createRoleDesktop,
    createRole2Desktop,
    createRole3Desktop,
    addPermDesktop,
    deletingPermDesktop,
    deletingPerm2Desktop,
    deletingRoleDesktop,
    deletingRole2Desktop,
    renamingRolesSelect,
    renamingRolesEdit,
    saveCompanyProfDesktop,
    editingCompPropDesktop,
    saveChangesDesktop,
    saveServiceTypeDesktop,
    editingServiceDesktop1,
    editingServiceDesktop2,
    creatingCredDesktop1,
    creatingCredDesktop2,
    addingCovCredDesktop,
    editCredNameDesktop1,
    editCredNameDesktop2,
    deleteCovCredDesktop,
    addingNewDepDesktop,
    editingDepDesktop1,
    editingDepDesktop2,
    addingNewJobDesktop,
    editingJobTitleDesktop1,
    editingJobTitleDesktop2,
    addingPayTypesDesktop,
    editPayTypeDesktop1,
    editPayTypeDesktop2,
    addingMileageDesktop,
    editingMilDesktop1,
    editingMilDesktop2,
    inactivatingMilDesktop,
    referenceCommonDesktop,
    editingPlaceDesktop1,
    editingPlaceDesktop2,
    createPayerDesktop1,
    createPayerDesktop2,
    activeInactivePayerDesktop,
    addServPayerDesktop1,
    addServPayerDesktop2,
    addChargeRateDesktop1,
    addChargeRateDesktop2,
    addChargeRateDesktop3,
    billingSetupDesktop,
    downloadingCsvDesktop,
    editingPayerDesktop1,
    editingPayerDesktop2,
    editingPayerServiceDesktop1,
    editingPayerServiceDesktop2,
    addNotePayerDesktop,
    editingPayerNotesDesktop,
    deletePayerNotesDesktop,
    viewPayerChangeHistoryDesktop,
    uploadPayerFilesDesktop1,
    uploadPayerFilesDesktop2,
    editPayerFilesDesktop,
    deletingPayerFilesDesktop,
    downPayerFilesDesktop,
    viewPayerFilesDesktop,
    changeProfDesktop,
    userChangePassDesktop,
    addClientDesktop,
    addContactClientDesktop,
    addEnrolClientDesktop1,
    addEnrolClientDesktop2,
    addNoteClientDesktop,
    editClientFilesDesktop,
    editClientNoteDesktop,
    deleteClientNoteDesktop,
    addFileClientDesktop,
    viewClientFileDesktop,
    editClientFileDesktop,
    downClientFilesDesktop,
    deleteClientFilesDesktop,
    assignStaffClientDesktop,
    deletAssignStaffClientDesktop,
    viwAssignStaffClientDesktop,
    addAuthClientDesktop1,
    addAuthClientDesktop2,
    addAuthServClientDesktop1,
    addAuthServClientDesktop2,
    editClientAuthDesktop1,
    editClientAuthDesktop2,
    editAuthServiceDesktop,
    viewPastAuthDesktop1,
    viewPastAuthDesktop2,
    manageApptAuthDesktop1,
    manageApptAuthDesktop2,
    editClientContDesktop,
    deletClientContDesktop,
    editGenInfoClientDesktop,
    editOtherInfoClientDesktop,
    deleteAddressClientDesktop,
    editAddressClientDesktop,
    settingAddressAsDefDesktop1,
    settingAddressAsDefDesktop2,
    downClientCsvDesktop,
    viewClientPprofChangeDesktop,
    clientActiveInActiveDesktop,
    editPrimSecondEnrollDesktop1,
    editPrimSecondEnrollDesktop2,
    termPrimSecondEnrolDesktop1,
    termPrimSecondEnrolDesktop2,
    settingSecondEnrollPrimDesktop1,
    settingSecondEnrollPrimDesktop2,
    addAddresClientDesktop,
    downCsvStaffDesktop,
    addStaffDesktop1,
    addStaffDesktop2,
    addStaffPayDesktop1,
    addStaffPayDesktop2,
    addStaffTimePayDesktop1,
    addStaffTimePayDesktop2,
    addStaffTimeFixedPayDesktop1,
    addStaffTimeFixedPayDesktop2,
    addStaffCredDesktop1,
    addStaffCredDesktop2,
    addStaffNotesDesktop,
    viewStaffProfChangeHistoryDesktop,
    addStaffFilesDesktop1,
    addStaffFilesDesktop2,
    addEditStaffGenInfoDesktoop1,
    addEditStaffGenInfoDesktoop2,
    addStaffOtherDetailsDesktop1,
    addStaffOtherDetailsDesktop2,
    addStaffCurrPastEmplDesktop1,
    addStaffCurrPastEmplDesktop2,
    viewStaffCurrentEmpDesktop1,
    viewStaffCurrentEmpDesktop2,
    viewStaffPastEmplDesktop,
    editStaffTimesheetDesktop,
    editStaffCredentialDesktop,
    viewStaffCredDesktop,
    deleteStaffCredDesktop,
    deleteStaffServiceDesktop,
    editStaffNotesDesktop,
    deleteStaffNotesDesktop,
    deleteStaffFileDesktop,
    editStaffPastMemberDesktop1,
    editStaffPastMemberDesktop2,
    deleteStaffMemberEmployDesktop1,
    deleteStaffMemberEmployDesktop2,
    deleteStaffMemberEmployDesktop3,
    activeInactiveStaffDesktop,
    viewPendClaimDesktop,
    generateClaimDesktop1,
    deleteStaffAccessDesktop,
    settingStaffAvailDesktop,

    authImage,
    authImageSmall,
    ScheduleTabDone,
    ScheduleTab,
    logo,
    MenuIcon,
    MenuCloseIcon,
    ClientMgmt,
    ClientMgmtMark,
    ClientMgmtScreen,
    StaffMgmt,
    StaffMgmtMark,
    StaffMgmtScreen,
    FSMgmt,
    FSMgmtMark,
    FSMgmtScreen,
    AccessMgmt,
    AccessMgmtMark,
    AccessMgmtScreen,
    Scheduling,
    SchedulingMark,
    SchedulingScreen,
    Billing,
    BillingMark,
    BillingScreen,
    CustomerOne,
    CustomerTwo,
    Quotes,
    LeftArrow,
    RightArrow,
    Warning,
    CloseIcon,
    Knowledge,
    ScheduleScreen,
    MenuMobileIcon,
};

export const Svg = {
    UsersSvg,
    UsersPlusSvg,
    AwardSvg,
    ArrowRight3,
    EmptyNotAndAlerts,
    PlusCircle,
    NotificationsActiveSvg,
    BookHelpSvg,
    HeaderLogo,
    FooterLogo,
    FacebookFooter,
    LinkedinFooter,
    YoutubeFooter,
    InstagramFooter,
    TwitterFooter,
    SmsSvg,
    LockPassSvg,
    CheckSvg,
    Check2Svg,
    CloseSvg,
    OpenWidgetSvg,
    DragHandleSvg,
    CloseGraySvg,
    ChevronRightSvg,
    AlertCircleSvg,
    AddCircleSvg,
    CheckCircleSvg,
    UpcomingApptWidgetDash,
    ClientOverviewWidgetDash,
    ExpiringCredWidgetDash,
    NotAlertsWidgetDash,
    AssignedClientsWidgetDash,
    MyProfileWidgetDash,
    MyTasksWidgetDash,
    ExpiringAuthWidgetDash,
    InsuranceAlertsWidgetDash,
    SessionNoteReqWidgetDash,
    SessionNoteDocSvg,
    SessionNoteAddSvg,
    EyeSvg,
    EyeHideSvg,
    CheckEmailSvg,
    ArrowRight2Svg,
    ClipboardPlusSvg,
};

export const landingImages = {
    smartScheduling,
    authorizationComplianceTracking,
    billingClaimsAutomation,
    clientStaffManagement,
    taskWorkflow,
    reports,

    masteryTracking,
    integratedNotes,
    quickSession,
    templatesPrompt,
    mobileFirstData,
    offlineMode,

    bannerInfoImg,
    bannerInfoImgSmall,
    bannerImg,
    bannerImgSmall,
    whyTherapyBeck,
    whyTherapyBeckSmall,
    PManagementSvg,
    DataCollSvg,
    RCycleSvg,
    BlackLogo,
    ButtonArrow,
    Play,
    HomeClient,
    empowering,
    whyTherapyCard1,
    whyTherapyCard2,
    whyTherapyCard3,
    whyTherapyCard4,
    technologicalImg,
    accessKayImage,
    accessKayImageMobile,
    appStore,
    googlePlay,
    customerOne,
    customerTwo,
    backInfinityFeatures,
    AboutUsBanner,
    banner1,
    banner1hovered,
    theMissionImg,
    electronic,
    electronicWeb,
    schedulingImg,
    payrollManag,
    autoClaims,
    aiPowered,
    billingDegree,
    dataSecurity,
    customizableReports,
    customizableReportsTablet,
    accessKeyFeatures,
    accessKeyFeaturesTablet,
    billingDirect,
    billingConsulting,
    credentialing,
    powerfulIntegrations,
    billingPosting,
    vectorImg,
    schedulingCalendar,
    clinicalHeroImg,
    clinicalHeroImgSmall,
    realTimeImg,
    realTimeImgSmall,
    customProgramsImg,
    customProgramsImgSmall,
    integratedSessionImg,
    integratedSessionImgSmall,
    automatedGraphingImg,
    automatedGraphingImgSmall,
    oneLoginImg,
    oneLoginImgSmall,
    readySecurityImg,
    readySecurityImgSmall,

    practiceHeroImg,
    practiceHeroImgSmall,
    completelyAutomatedImg,
    completelyAutomatedImgSmall,
    smartSchedulingImg,
    smartSchedulingImgSmall,
    payrollReadyImg,
    payrollReadyImgSmall,
    customReportingImg,
    customReportingImgSmall,
    mobileAppFunctionalityImg,
    mobileAppFunctionalityImgSmall,
    onePlatformImg,
    onePlatformImgSmall,
    alignedSecurityImg,
    alignedSecurityImgSmall,
    abaBillingHeroImg,
    abaBillingHeroImgSmall,
    abaBillingGuardrailsImgSmall,
    abaBillingGuardrailsImg,
    abaBillingRcmAgentsImgSmall,
    abaBillingRcmAgentsImg,
    abaBillingAutomatedImgSmall,
    abaBillingAutomatedImg,
    abaBillingEligibilityImgSmall,
    abaBillingEligibilityImg,
    abaBillingReportingImgSmall,
    abaBillingReportingImg,
    abaBillingConnectedImgSmall,
    abaBillingConnectedImg,
    abaBillingRcmServicesImgSmall,
    abaBillingRcmServicesImg,

    managedBillingHeroImgSmall,
    managedBillingHeroImg,
    managedBillingWorkflowsImgSmall,
    managedBillingWorkflowsImg,
    managedBillingSpecialistsImgSmall,
    managedBillingSpecialistsImg,
    managedBillingVisibilityImgSmall,
    managedBillingVisibilityImg,
    managedBillingCleanerDataImgSmall,
    managedBillingCleanerDataImg,
    managedBillingProactiveRcmImgSmall,
    managedBillingProactiveRcmImg,
    managedBillingSecurityImgSmall,
    managedBillingSecurityImg,

    abaSchedulingHeroImgSmall,
    abaSchedulingHeroImg,
    abaSchedulingGuardrailsImgSmall,
    abaSchedulingGuardrailsImg,
    abaSchedulingRecurringImgSmall,
    abaSchedulingRecurringImg,
    abaSchedulingAuthImgSmall,
    abaSchedulingAuthImg,
    abaSchedulingStaffImgSmall,
    abaSchedulingStaffImg,
    abaSchedulingAvailabilityImgSmall,
    abaSchedulingAvailabilityImg,
    abaSchedulingAnalyticsImgSmall,
    abaSchedulingAnalyticsImg,
};

export const LandingSvg = {
    ContactMail,
    ContactPhone,
    ContactMapPin,
    FreeMonthsSvg,
    FreeOnboardingSvg,
    FreeDataTransferSvg,
    FreeSupportSvg,
    DisconnectedSystemsSvg,
    DataEntrySvg,
    PoorUserSvg,
    LimitedReportingSvg,
    HiddenFeesSvg,
    SlowSupportSvg,
    CheckIcon,
    InstagramContact,
    GooglePlaySvg,
    GooglePlay,
    GetItOnSvg,
    AppleSvg,
    DownloadOnThe,
    AppStoreSvg,
    ScheduleSvg,
    BillingSvg,
    PayrollPSvg,
    ReportingPSVG,
    RealTimePSVG,
    ProgramsPSVG,
    SessionNotesPSVG,
    GraphsPSVG,
    FasterSvg,
    FewerSvg,
    FinancialSvg,
    StressFreeSvg,
    ArrowRightSvg,
    PlaySvg,
    EMRSvg,
    InfinitySmallSvg,
    StarOrangeSvg,
    ArrowLeftCarousel,
    ArrowRightCarousel,
    Checkmark,
    CheckMarkSvg,
    ArrowDownSvg,
    callIconSvg,
    SmsStarSvg,
    AddressSvg,
    FacebookContactSvg,
    LinkedinContactSvg,
    TwitterContactSvg,
    OurBeginningsSvg,
    GrowthSvg,
    NetworkSvg,
    InnovationSvg,
    IntegritySvg,
    CollaborationSvg,
    getInTouchBg,
    FundingSourceSvg,
    ClientManagementSvg,
    StaffManagementSvg,
    VectorSvg,
    ZapSvg,
    FirstlineSvg,
    Note2Svg,
    BarChart2Svg,
    Square3Svg,
    SecuritySafeSvg,
    ReceiptSvg,
    ReceiptItemSvg,
    Calendar2Svg,
    MathSvg,
    CardEditSvg,
    MobileSvg,

    ZoomCardSvg,
    VbMappCardSvg,
    GCalendarCardSvg,
    OfficeAllyCardSvg,
    AvailityCardSvg,
    StripeCardSvg,
    TaskSvg,
    ArchiveTickSvg,
    PeopleSvg,
    PersonalCardSvg,
    DiagramSvg,
    LinkSvg,
    OnlineSupportSvg,
    ShieldTickSvg,
    RepeatSvg,
    Profile2UserSvg,
    ChartSvg,
};
